<template>
  <div class="count-wrp">
    <span class="calc-btn sub" :class="{on: +result > +min}" @click="onReduce"></span>
    <span class="result">{{result}}</span>
    <span class="calc-btn plus" :class="{on: +result < +max}" @click="onPlus"></span>
  </div>
</template>

<script>
  export default {
    name: 'bg-count',
    props: {
      value: {
        type: Number,
        default: 0,
      },
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: 0,
      },
      step: {
        type: Number,
        default: 1,
      },
    },
    data(){
      return {
        result: this.value,
      };
    },
    watch: {
      value(cur){
        this.result = cur;
      },
      result(cur){
        this.$emit('input', cur);
      },
    },
    methods: {
      onReduce(){
        if(this.result > this.min){
          this.result = this.result - this.step;
        }
      },

      onPlus(){
        if(this.max > this.result){
          this.result = this.result + this.step;
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .count-wrp{
    font-size: 0;
    user-select: none;

    span{
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
    .calc-btn{
      width: 24px;
      height: 24px;
    }
    .sub{
      background: url("/static/images/components/icon-sub-grey.png") no-repeat center center;

      &.on{
        background: url("/static/images/components/icon-sub-blue.png") no-repeat center center;

        &:hover{
          background: url("/static/images/components/icon-sub-hover.png") no-repeat center center;
        }
      }
    }
    .plus{
      background: url("/static/images/components/icon-plus-grey.png") no-repeat center center;

      &.on{
        background: url("/static/images/components/icon-plus-blue.png") no-repeat center center;

        &:hover{
          background: url("/static/images/components/icon-plus-hover.png") no-repeat center center;
        }
      }
    }
    .result{
      min-width: 50px;
      color: #666;
      font-size: 18px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BgCount/BgCount.vue